exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "strong{vertical-align:middle}.updates-content-container{padding:20px}\n", ""]);

